import API from "./api";

export interface LikeStatutDto {
  liked: boolean;
  total: number;
}

const LikeService = {
  statut: async (articleId: number, sessionId: string): Promise<LikeStatutDto> => {
    const response = await API.get("/likes", { params: { articleId, sessionId } });
    return response.data.donnees;
  },

  basculer: async (articleId: number, sessionId: string): Promise<LikeStatutDto> => {
    const response = await API.post("/likes", { articleId, sessionId });
    return response.data.donnees;
  },
};

export default LikeService;
